export const eng = {
  buttons: {
    bookTrialClass: "Book a trial class",
    backHome: "Home",
    loginAccount: "Log in your account",
    bookClass: "Book your free trial class",
    bookYourClass: "Book your class",
    registerFor: "Register for a free class",
    createAccount: "Create account",
    verItalki: "View my italki profile",
    visitaMiPerfil: "Visit my italki profile",
    perfilItalki: "italki Profile",
    mensajeWhatsapp: "Message on WhatsApp",
  },
  nav: {
    howToStart: "How to start?",
    aboutMe: "About me",
  },
  error: "Ops, page not found",
  trialClassForm: {
    title: "Let's start your learning Spanish adventure",
    description: "Please fill the form below and I will get in touch to schedule a convenient time for your trial class.",
    terms:
      "By creating an account, you agree to our Terms and Conditions . You will receive emails and notifications from Spanish with Monse about your learning progress and our services, which you can unsubscribe at any time free of charge. We will process your personal data in accordance with our Privacy policy.",
  },
  thanks: {
    title: "Thanks for register!",
    info: "I'll send you more information to scheduled your trial class soon",
    back: "Back home"
  },
  form: {
    name: "Name:",
    namePlaceholder: "*Name",
    errorName: {
      addName: "Please add your name",
      noNumbers: "Please don't use numbers"
    },
    email: "Email:",
    emailPlaceholder: "*Email",
    addEmail: "Please add your email",
    addValidEmail: "Please add a valid Email",
    password: "Password:",
    passwordPlaceholder: "*Password",
    addPassword: "Please add your password",
    useSixCharacters: "Use at least 6 characters",
    oneNumber: "Please add at least 1 number",
    goal: "Select your goal",
    addGoal: "Please add your goal",
    beginner: "Beginner",
    conversation: "Conversation",
    nextLevel: "Next Level",
    errorRegister: "There was a problem, plase, check your information.",
    errorLogin: "The email address or password you entered is incorrect."
  },
  main: {
    hero: {
      title:
        "Speak Spanish with <1>confidence</1> from your very first class",
      description:
        "Private online lessons. Learn at your own pace, on the topics that matter to you.",
    },
    benefits: {
      title:
        "Enjoy the <1>benefits</1> of learning Spanish in private online lessons.",
      Rhythm:
        "Follow your rhythm",
      RhythmText:
        "Your pace, your schedule, no pressure to keep up with a group.",
      Conversationstext:
        "Conversations about what matters to you: travel, work, family, whatever you like.",
      Place:
        "Whenever you are",
      PlaceText:
        "Learn from anywhere in the world, all you need is an internet connection.",
      PlanText:
        "A plan built for you, not a one-size-fits-all program.",
      Topics:
        "Topics you're interested in",
      TopicsText:
        "Learn through topics you already enjoy. Spanish becomes the tool, not the obstacle.",
      Questions:
        "Answer your questions",
      QuestionsText:
        'Ask anything, without feeling like "the one who didn\'t get it".',
    },
    goals: {
      title:
        "Every lesson is built around your <1>goal</1>",
      subtitle:
        "Which one is yours?",
      beginner:
        "Learn to communicate in Spanish from scratch — in a practical way, without getting overwhelmed by rules. We start with what you actually need to say today.",
      beginnerList:
        `<1>It's your first time trying to learn Spanish.</1>
        <1>You understand a little, but grammar feels like a mystery.<1/>`,
      conversation:
        "You know some Spanish, but when it's time to speak, the words don't come. That's exactly what we work on: getting your ideas out — naturally and confidently.",
      conversationList:
        `<1>You have the basics, but struggle to hold a real conversation.</1>
        <1>You freeze up when you try to express your ideas.</1>
        <1>You want to practice topics from everyday life.</1>`,
      nextLevel:
        'Your Spanish works — but you want more: better pronunciation, complex texts, specialized vocabulary. We\'ll define together what "the next level" looks like for you.',
      nextLevelList:
        `<1>You get by just fine, but want to sound more natural.</1>
        <1>You want to discuss specialized or technical topics.</1>
        <1>You're working on pronunciation, writing, or comprehension.</1>`,
    },
    banner1: {
      title:
        "Still not sure? Start with a free lesson",
      content:
        "No long forms, no credit card — just 30 minutes to see what this is all about.",
    },
    banner2: {
      title:
        "Still not sure?",
      content:
        "That's okay. That's exactly why the first lesson is free. No long forms, no credit card, just 30 minutes to see how we work and decide when you're ready.",
    },
    trustBar: {
      title: "Over 8 years of teaching Spanish to students around the world",
      1: "5,000+",
      label1: "lessons taught online",
      2: "1,800+",
      label2: "lessons taught on italki",
      3: "5.0",
      label3: "rating on italki",
      button: "View reviews on italki",
    },
    howToStart: {
      title: "Getting started is <1>easier</1> than you think. Just three steps:",
      1: "Tell me what you want to achieve",
      2: "Book your trial lesson",
      3: "Choose the plan that works for you",
    },
    aboutMe: {
      title:
        "¡Hola! my name is Monserrat, but you can call me Monse.",
      intro:
        "I am Spanish teacher, Mexican, and someone who once got stranded on a ship in the Caribbean with 300 people from 60 countries — and no internet. That experience taught me that connecting with someone in their language is worth more than any certificate.",
      content:
        "I've been teaching Spanish online for over 8 years, shaping every lesson around the person in front of me: their pace, their goals, their way of learning. Not sure where to start? Finding that path together is part of the job.",
      visitProfile:
        "Visit my italki profile",
      messageWhatsapp:
        "Message on WhatsApp",
    },
    testimonials: {
      title: "What my <1>students</1> say",
      calltoaction: "See more reviews from others students.",
      testimonial1: {
        name: "Audrey",
        country: "United States",
        comment: "I'll say it again: Monse is an incredible teacher! I've now been taking classes with her for three years (!!!) and can confidently say that she is patient, kind, fun, and wholly dedicated to her students' success. She customizes each class, still puts up with my bad jokes (but they've gotten better, along with my Spanish), and continues to help me understand the reasoning behind new concepts. She's exceptionally organized and comes prepared every time, but pivots easily when I have questions or need extra help. Her encouragement is genuine — and I'm so grateful to have lucked out with a teacher who I now also call a friend!",
      },
      testimonial2: {
        name: "Elaine",
        country: "Hong Kong",
        comment: "As a language teacher myself, I know exactly how hard it can be to make a lesson both fun and useful for students. Monse is very patient and motivating, and she brings a lot of positive energy to our classes. At first, I didn’t feel very comfortable speaking Spanish, but in her lessons I always find myself saying more, and she consistently uses Spanish to make the class more immersive. I really appreciate her teaching style and definitely recommend her to other learners!",
      },
      testimonial3: {
        name: "Alexander",
        country: "Germany",
        comment: "Monse is an excellent teacher. She always encourages me to speak a lot during class, corrects my mistakes with patience, which helps a lot to improve my Spanish. Also, the lessons are very well structured and the optional homework helps me to deepen what I have learned. She has been a great support for me!",
      },
      testimonial4: {
        name: "Lauren",
        country: "United States",
        comment: "Classes with Monse are always so fun! When I'm having a bad day, our class always puts a smile on my face. When you are learning Spanish, some days you can speak well and other days you can barely string a sentence together. Either way, Monse is patient, encouraging and fun to talk to.",
      },
    },
  },
};